import toast, { ToastBar, Toaster } from 'react-hot-toast';
import 'react-toastify/dist/ReactToastify.css';
import './app.css';
import './assets/fonts/flaticon.css';
import './assets/styles/style.css';
import Body from './shared-components/body/body';
const light = `:root {
  --white: #fff;
  --body-background: #f5f7f9;
  --secondary: #333333;
  --light-secondary: #414141;
  --lightest-secondary: #666666;
  --black: #000000;
  --text-color: #343a43;
  --light-text: #868686;
  --dark-text: #141312;
  --label-color: #212121;
  --light-label: #424242;
  --border-color: #e6e6e6;
  --input-border: #e8e8e8;
  --card-border: #ededed;
  --shadow-color: rgba(0,0,0,.03);
  --darker-gray: #121212;
  --gray: #a6a6a6;
  --light-gray: #dfdfdf;
  --lightest-gray: #f9f9f9;
  --accordian-bg: #ffffff;
  --accordian-border: #e1e1e1;
}
`;

const dark = `:root {
  --white: #212121;
  --body-background: #1c1c1c;
  --secondary: #0f0f0f;
  --light-secondary: #303030;
  --lightest-secondary: #3b3b3b;
  --black: #ffffff;
  --text-color: #efefef;
  --light-text: #a6a6a6;
  --dark-text: #e1e1e1;
  --label-color: #a6a6a6;
  --light-label: #707070;
  --border-color: #303030;
  --input-border: #3c3c3c;
  --card-border: #303030;
  --shadow-color: rgba(0,0,0,.03);
  --darker-gray: #121212;
  --gray: #7b7a7a;
  --light-gray: #434343;
  --lightest-gray: #252525;
  --accordian-bg: #343434;
  --accordian-border: #444444;
}
.tableFooter .pageLimit,
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn.btn-primary,
.btn-primary,
button#nav-toogle,
#left-sidebarNav nav ul li a {
	color: var(--black);
}
.aside-footer svg,
#left-sidebarNav .nav-inner svg {
	fill: var(--black);
}
.btn-outline-secondary {
	color: #dadadb;
	border-color: #a4a8ac;
}
.bg-light {
	background-color: #28292b !important;
}
.accordion-button::after {
	filter: invert(1);
}
.custom-select,
select.form-control:not([size]):not([multiple]) {
	background: var(--white) url("data:image/png;base64,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") no-repeat right .75rem center/auto 12px
}
::-webkit-scrollbar-corner {
  background: var(--white);
}
`;
const App = () => {
  return (
    <div
      className="App"
      data-testid="AppDiv"
    >
      <Body />
      <Toaster
        position="top-right"
        reverseOrder={true}
      >
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type !== 'loading' && (
                  <button onClick={() => toast.dismiss(t.id)}>
                    <i className="close">&times;</i>
                  </button>
                )}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>
    </div>
  );
};

export default App;
